
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8EREH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $94e4f26f69b4c38e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $94e4f26f69b4c38e$export$2e2bcd8739ae039 = {
    'fabric.editor.chromeCollapsedPlaceholder': "Escribe algo\u2026",
    'fabric.editor.editorAssistiveLabel': "\xc1rea de contenido principal, empieza a escribir para introducir texto.",
    'fabric.editor.headingLink.toolbarHelpTitle': "Abrir di\xe1logo de ayuda"
};

});


//# sourceMappingURL=es.8457142c.js.map
